// extracted by mini-css-extract-plugin
export default {"popup":"__popup__AoZR-","block":"__block__PmFkX","blocksConatiner":"__blocksConatiner__RwTRH"};